import {
    UPLOAD_TO_GENERATE_LINK_REQUEST,
    UPLOAD_TO_GENERATE_LINK_SUCCESS,
    UPLOAD_TO_GENERATE_LINK_FAILURE,
    RESET_UPLOAD_TO_GENERATE_LINK,
} from "../types/index";

const initialState = {
    isLoading: false,
    success:      false,
    network:      false,
    failed:       false,
    data:         {},
    message:      "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {

        case UPLOAD_TO_GENERATE_LINK_REQUEST:
            return {
                ...state,
                isLoading:    true,
                success:      false,
                failed:       false,
                network:      false,
                data:         {},
                message:      "",
                networkError: "",
            };

        case UPLOAD_TO_GENERATE_LINK_SUCCESS:
            return {
                ...state,
                isLoading:    false,
                success:      true,
                failed:       false,
                network:      false,
                data:         action.payload,
                message:      "",
                networkError: "",
            };

        case UPLOAD_TO_GENERATE_LINK_FAILURE:
            return {
                ...state,
                isLoading:    false,
                success:      false,
                failed:       true,
                network:      false,
                data:         action.payload,
                message:      "",
                networkError: "",
            };

        case RESET_UPLOAD_TO_GENERATE_LINK:
            return (state = initialState);

        default:
            return state;
    }
};